"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.updateUserImageStarted = exports.updateUserImageFailed = exports.updateUserImageSuccess = exports.updateUserImageAjax = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _createAjaxEpic = require("../../../redux/createAjaxEpic");

var _UserActions = require("../../models/UserActions");

var _userApi = require("../userApi");

var _userRegistry = require("../userRegistry");

var updateUserImageAjax = function updateUserImageAjax(ajax, action) {
  if (!action.payload) {
    return _rxjs.Observable.empty();
  }

  return ajax.putJSON((0, _userApi.updateMyImageUrl)(action.payload)).pipe((0, _operators.mergeMap)(function () {
    return [];
  }), (0, _operators.catchError)(function (error) {
    return _rxjs.Observable.of(error);
  }));
};

exports.updateUserImageAjax = updateUserImageAjax;

var updateUserImageSuccess = function updateUserImageSuccess(state) {
  var newState = (0, _objectSpread2.default)({}, state);

  if (newState.userImage) {
    newState.userImage.isUpdating = false;
    newState.userImage.isComplete = true;
  }

  return newState;
};

exports.updateUserImageSuccess = updateUserImageSuccess;

var updateUserImageFailed = function updateUserImageFailed(state, _action) {
  return (0, _objectSpread2.default)({}, state);
};

exports.updateUserImageFailed = updateUserImageFailed;

var updateUserImageStarted = function updateUserImageStarted(state) {
  var newState = (0, _objectSpread2.default)({}, state);

  if (newState.userImage) {
    newState.userImage.isUpdating = true;
    newState.userImage.isComplete = false;
  }

  return newState;
};

exports.updateUserImageStarted = updateUserImageStarted;

_userRegistry.userRegistry.add((0, _createAjaxEpic.getSuccessActionType)(_UserActions.UserActions.updateUserImage), updateUserImageSuccess);

_userRegistry.userRegistry.add((0, _createAjaxEpic.getFailureActionType)(_UserActions.UserActions.updateUserImage), updateUserImageFailed);

_userRegistry.userRegistry.add(_UserActions.UserActions.updateUserImage, updateUserImageStarted);

(0, _createAjaxEpic.addAjaxEpic)(_userRegistry.userRegistry, _UserActions.UserActions.updateUserImage, updateUserImageAjax);